import { useBrandTerminology } from './useBrandTerminology';

export const useBrandProductConfig = () => {
  const { getFeatureEnabled } = useBrandTerminology();
  
  return {
    enableCategories: getFeatureEnabled('categories'),
    enableSubcategories: getFeatureEnabled('subcategories'),
    enableTags: getFeatureEnabled('tags'),
    enableMoreTags: getFeatureEnabled('more_tags'),
    enableTag3: getFeatureEnabled('tag3'),
  };
};
